/**
 * Feature toggles — set false to hide surfaces for a minimal / review build.
 */

/** Master: Instagram in the product (automation nav, Page→IG link, competitor IG fields). */
export const SHOW_INSTAGRAM_UI = true;

export const SHOW_INSTAGRAM_AUTOMATION = SHOW_INSTAGRAM_UI;
export const SHOW_GROUP_SHARING = true;

/**
 * Competitors page + docs topic. Set false for Meta App Review builds to hide UI (Phase 4.6).
 * Pair with backend ENABLE_COMPETITOR_SCRAPING=false to stop scrapes.
 */
export const SHOW_COMPETITORS_UI = true;

/**
 * Standalone “Connect Instagram” on Dashboard + Clients (username/password or direct OAuth).
 * Feed publish is FB Page → linked IG Business only — keep this false.
 */
export const SHOW_STANDALONE_INSTAGRAM_CONNECT = false;

/**
 * Offer Instagram as a primary publish/schedule platform target.
 * When false, operators publish to Facebook; dual-publish handles IG via Page link.
 */
export const SHOW_INSTAGRAM_AS_PUBLISH_TARGET = false;

/** Doc topic ids (match Docs.js topic keys and paths like /docs/:topic) */
export function isDocTopicVisible(topicId) {
  if (!SHOW_INSTAGRAM_UI && topicId === 'instagram-automation') {
    return false;
  }
  if (!SHOW_GROUP_SHARING && topicId === 'group-sharing') {
    return false;
  }
  if (!SHOW_COMPETITORS_UI && topicId === 'competitors') {
    return false;
  }
  return true;
}
